import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import strings from '../locales/';

const Header = props => (
  <div className="header between">
    <div className="header_box_filter">
      <div className="box-form islabel box300 icon icon_search">
        <div>
          <label>{props.language ? props.language.search : ''}</label>
        </div>
        <div>
          <input onChange={props.handleSearch} autoComplete="off" type="text" id="search" />
        </div>
      </div>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/homologation_driver/header.jsx